import { Component, EventEmitter, ViewChild, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ComponentBase } from '../../../_infrastructure/classes/componentBase';
import { HttpParams } from '@angular/common/http';
import { UntypedFormBuilder } from '@angular/forms';
import { Table } from 'primeng/table';
import { WUnlocodeViewModel, WUnlocodeItemResultsViewModel, Tc } from 'src/app/components/core/_infrastructure/types/common';
import { GlobalService } from 'src/app/components/core/_infrastructure/classes/services/global.service';
import { Dialog } from 'primeng/dialog';
import { Output } from '@angular/core';
import { ExceptionManager } from '../../../_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../_infrastructure/classes/services/notification.service';

@Component({
    selector: 'app-unlocodepopup',
    templateUrl: './unlocodePopup.component.html',
})
export class UnlocodePopupComponent extends ComponentBase implements OnInit, OnChanges {
    @Input() idPais: number;
    @Input() listPais: Tc[];
    // emit para el grid en modo selección doble clic en la fila a seleccionar
    @Output() selected: EventEmitter<WUnlocodeViewModel> = new EventEmitter();

    @ViewChild('tableSearch') turboTable: Table;

    resultUnlocodes: WUnlocodeItemResultsViewModel;
    display = false;

    cols: any[];
    selectedUnlocode?: WUnlocodeViewModel | null;

    existeParametroGrupo = false;
    isCollapsed = false;

    constructor(
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.createColumns();
        this.createForm();
        this.updateForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.idPais?.currentValue) {
            this.form?.patchValue({
                CodPais: changes.idPais.currentValue,
            });
        }
    }

    private createColumns(): void {
        this.cols = [
            { field: 'CodPais', header: 'CodPais', display: 'none' },
            { field: 'Descripcion', header: 'País' },
            { field: 'CodLocation', header: 'Código Localización' },
            { field: 'DescripcionLocation', header: 'Localización' },
            { field: 'CodSubDivision', header: 'Código Subdivisión', display: 'none' },
            { field: 'DescripcionSubDivision', header: 'Subdivisión' },
        ];
    }

    private createForm(): void {
        this.form = this.fb.group({
            CodPais: null,
            Descripcion: '',
        });
    }

    onSearchButton(): void {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.search(0);

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    private search(pageNumber: number, asc = 0, orderBy = ''): void {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('CodPais', this.form.value.CodPais);
        params = params.append('Descripcion', this.form.value.Descripcion);

        this.loading = true;

        this.globalService.getUnlocodeExtendedPagedByFilter(params).subscribe(result => {
            this.resultUnlocodes = result;
            this.loading = false;
        });
    }

    onSearchLazy(event: any): void {
        if (!event.rows) {
            return;
        }

        let pageNumber = event.first / event.rows;

        this.search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton(): void {
        this.form.patchValue({
            CodPais: this.idPais,
            Descripcion: '',
        });

        this.searchingButton = false;
        this.isCollapsed = false;
        this.selectedUnlocode = null;
        this.resultUnlocodes = new WUnlocodeItemResultsViewModel();
    }

    showDialog(): void {
        this.display = true;
        //Borra datos introducidos en llamadas anteriores en campos del formulario
        this.onCleanButton();
        this.resultUnlocodes = new WUnlocodeItemResultsViewModel();
    }

    //emit para grid en modo selcción doble clic en la fila a seleccionar
    onRowDblClick($event: any, selection: WUnlocodeViewModel): void {
        $event?.stopPropagation();
        this.selectedUnlocode = selection;
        this.emitSelectedUnlocode($event);
    }

    private emitSelectedUnlocode($event: any): void {
        this.display = false;
        this.searchingButton = false;
        if (this.selectedUnlocode) {
            this.selected.emit(this.selectedUnlocode);
        }
    }

    acceptDialog(): void {
        this.display = false;
        this.selected.emit(this.selectedUnlocode!);
    }

    cancelDialog(): void {
        this.display = false;
    }

    showDialogMaximized(dialog: Dialog): void {
        setTimeout(() => {
            dialog.maximize();
        }, 0);
    }

    onSelect($event: any, selection: WUnlocodeViewModel): void {
        $event?.stopPropagation();
        this.selectedUnlocode = selection;
    }

    get noAccepted(): boolean {
        return !this.form.valid || !this.selectedUnlocode;
    }

    /**
     * Para controlar la propiedad disabled del botón de reset.
     * @returns boolean
     */
    get formIsUntouched(): boolean {
        return this.form.pristine || !this.form.dirty;
    }

    private updateForm(): void {
        this.form.patchValue({
            CodPais: this.idPais || '',
            Descripcion: '',
        });
    }
}
